export default __webpack_public_path__ + "15e6f1186e0521a3b167052646088e60.jpeg";